<template>
  <Header />
  <router-view />
</template>

<script>
import Header from "./web/global/global-header.vue";

export default {
  name: "App",
  components: {
    Header,
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  margin: 0;
}
</style>
